import React, { useEffect, useRef, useState } from 'react'
import styles from './PhoneCountrySelect.module.scss'
import ArrowDropdown from '../../img/IconComponents/ArrowDropdown'
import cn from 'classnames'
import at from '../../img/at.svg'
import be from '../../img/be.svg'
import bg from '../../img/bg.svg'
import hr from '../../img/hr.svg'
import cy from '../../img/cy.svg'
import cz from '../../img/cz.svg'
import dk from '../../img/dk.svg'
import ee from '../../img/ee.svg'
import fi from '../../img/fi.svg'
import fr from '../../img/fr.svg'
import de from '../../img/de.svg'
import gr from '../../img/gr.svg'
import hu from '../../img/hu.svg'
import ie from '../../img/ie.svg'
import it from '../../img/it.svg'
import lv from '../../img/lv.svg'
import lt from '../../img/lt.svg'
import lu from '../../img/lu.svg'
import mt from '../../img/mt.svg'
import nl from '../../img/nl.svg'
import pl from '../../img/pl.svg'
import pt from '../../img/pt.svg'
import ro from '../../img/ro.svg'
import sk from '../../img/sk.svg'
import si from '../../img/si.svg'
import es from '../../img/es.svg'
import se from '../../img/se.svg'
import ch from '../../img/ch.svg'
import en from '../../img/en.svg'
import Element from './Components/Element/Element'
import Overlay from '../Overlay/Overlay'
import { useTranslation } from 'react-i18next'

const PhoneCountrySelect = ({
  currentLang,
  setCurrentLang,
  setCountryCode,
}) => {
  const { t } = useTranslation()
  const langOption = [
    t('Austria'),
    t('Belgium'),
    t('Bulgaria'),
    t('Croatia'),
    t('Cyprus'),
    t('Czech Republic'),
    t('Denmark'),
    t('Estonia'),
    t('Finland'),
    t('France'),
    t('Germany'),
    t('Greece'),
    t('Hungary'),
    t('Ireland'),
    t('Italy'),
    t('Latvia'),
    t('Lithuania'),
    t('Luxembourg'),
    t('Malta'),
    t('Netherlands'),
    t('Poland'),
    t('Portugal'),
    t('Romania'),
    t('Slovakia'),
    t('Slovenia'),
    t('Spain'),
    t('Sweden'),
    t('Switzerland'),
    t('United Kingdom'),
  ]

  const [isOpen, setIsOpen] = useState(false)

  const menuRef = useRef()

  const getCountryData = (countryName) => {
    // eslint-disable-next-line default-case
    switch (t(countryName)) {
      case t('Austria'):
        return { image: at, code: '+43' }
      case t('Belgium'):
        return { image: be, code: '+32' }
      case t('Bulgaria'):
        return { image: bg, code: '+359' }
      case t('Croatia'):
        return { image: hr, code: '+385' }
      case t('Cyprus'):
        return { image: cy, code: '+357' }
      case t('Czech Republic'):
        return { image: cz, code: '+420' }
      case t('Denmark'):
        return { image: dk, code: '+45' }
      case t('Estonia'):
        return { image: ee, code: '+372' }
      case t('Finland'):
        return { image: fi, code: '+358' }
      case t('France'):
        return { image: fr, code: '+33' }
      case t('Germany'):
        return { image: de, code: '+49' }
      case t('Greece'):
        return { image: gr, code: '+30' }
      case t('Hungary'):
        return { image: hu, code: '+36' }
      case t('Ireland'):
        return { image: ie, code: '+353' }
      case t('Italy'):
        return { image: it, code: '+39' }
      case t('Latvia'):
        return { image: lv, code: '+371' }
      case t('Lithuania'):
        return { image: lt, code: '+370' }
      case t('Luxembourg'):
        return { image: lu, code: '+352' }
      case t('Malta'):
        return { image: mt, code: '+356' }
      case t('Netherlands'):
        return { image: nl, code: '+31' }
      case t('Poland'):
        return { image: pl, code: '+48' }
      case t('Portugal'):
        return { image: pt, code: '+351' }
      case t('Romania'):
        return { image: ro, code: '+40' }
      case t('Slovakia'):
        return { image: sk, code: '+421' }
      case t('Slovenia'):
        return { image: si, code: '+386' }
      case t('Spain'):
        return { image: es, code: '+34' }
      case t('Sweden'):
        return { image: se, code: '+46' }
      case t('Switzerland'):
        return { image: ch, code: '+41' }
      case t('United Kingdom'):
        return { image: en, code: '+44' }
      default:
        return { image: en, code: '+44' }
    }
  }

  const setLang = (e) => {
    setIsOpen(false)
    setCurrentLang(e.target.textContent)
    setCountryCode(getCountryData(e.target.textContent).code)
  }

  const closeModalHandler = (e) => {
    if (e.target.className === 'overlay') {
      e.stopPropagation()
      setIsOpen(false)
    }
  }

  useEffect(() => {
    menuRef.current.scrollTo(0, 0)
  }, [currentLang])

  return (
    <div className={cn(styles.lang, isOpen ? styles.lang__open : '')}>
      {isOpen ? <Overlay closeModalHandler={closeModalHandler} /> : null}
      <div
        className={styles.lang__info}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <img src={getCountryData(currentLang).image} alt="country" />
        <ArrowDropdown rotate={isOpen ? '180deg' : '0deg'} />
      </div>
      <div className={styles.lang__menu} ref={menuRef}>
        {[
          t(currentLang),
          ...langOption.filter((el) => el !== t(currentLang)),
        ].map((lang) => {
          const { image, code } = getCountryData(lang)

          return (
            <Element
              text={lang}
              icon={image}
              key={lang}
              code={code}
              action={setLang}
              active={currentLang === lang}
            />
          )
        })}
      </div>
    </div>
  )
}

export default PhoneCountrySelect
